/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AppShortcutValueType {
    Text = 1,
    RelativeDate = 2,
    Entity = 3,
}
